<template>
  <div>
    <!-- User Info: Input Fields -->
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent="onSubmitForm">
        <b-row>

          <!-- Field: Username -->
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Nome do Banner"
              label-for="banner-titulo"
            >
              <validation-provider
                #default="{ errors }"
                name="banner-titulo"
                rules="required"
              >
                <b-form-input
                  id="banner-titulo"
                  v-model="itemData.nome"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex.: Promoção"
                />
                <small class="text-danger">{{ errors[0] ? 'Titulo é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Link"
              label-for="banner-link"
            >
              <validation-provider
                #default="{ errors }"
                name="banner-link"
                rules="required"
              >
                <b-form-input
                  id="banner-link"
                  v-model="itemData.link"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex.: https://site.com.br"
                />
                <small class="text-danger">{{ errors[0] ? 'Link é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Status"
              label-for="ativo_cliente"
            >
              <v-select
                v-model="itemData.ativo"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[
                  { label: 'Ativo', value: 1 },
                  { label: 'Inativo', value: 0 },
                ]"
                :reduce="val => val.value"
                :clearable="false"
                input-id="ativo_cliente"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Tag"
              label-for="banner-link-botao"
            >
              <validation-provider
                #default="{ errors }"
                name="banner-link-botao"
                rules="required"
              >
                <b-form-input
                  id="banner-link-botao"
                  v-model="itemData.nome_tag"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex.: Masculino"
                />
                <small class="text-danger">{{ errors[0] ? 'Link é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="12"
            class="mt-2 align-images"
          >
            <FormImagens
              :item-data="itemData"
              @removeImagem="$emit('removeImagem')"
            />
          </b-col>

        </b-row>

        <!-- Action Buttons -->
        <b-button
          variant="primary"
          type="submit"
          class="my-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        >
          {{ disablesInput ? 'Atualizar' : 'Cadastar' }}
        </b-button>
        <b-button
          variant="outline-secondary"
          class="my-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="$router.push({ name: 'app-admin-banners' })"
        >
          Cancelar
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { onMounted, ref, computed } from '@vue/composition-api'
import useProdutosList from '@/views/apps/produtos/list/useProdutosList'
import store from '@/store'
import useOptionsMask from '@/composables/useOptionsMask'
import { useApi } from '@/composables/useApi'
import FormImagens from './FormImagens.vue'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    FormImagens,
  },
  model: {
    prop: 'itemData',
    event: 'handleSubmit',
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      email,
    }
  },
  setup(props, { emit }) {
    const itemData = computed({
      get: () => props.value,
      set: val => emit('update:value', val),
    })
    const { resolveUserRoleVariant } = useProdutosList()
    const { optionsMask } = useOptionsMask()
    const ufOptions = ref([])
    const simpleRules = ref(null)
    const cidadeOptions = ref([])
    const roleOptions = ref([])
    const categoriasItems = ref([])
    const tabelaPrecosOptions = ref([])

    const handleUfsChange = uf => {
      store.dispatch('appUfs/GET_UFS_BY_UF', uf)
      ufOptions.value = store.getters['appUfs/getUfs']
    }

    const handleCidadesChange = cidadeNome => {
      store.dispatch('appAdmProdutos/GET_CIDADES_BY_CIDADE_NOME', cidadeNome)
      cidadeOptions.value = store.getters['appAdmProdutos/getCidades']
    }

    const validationForm = () => {
      simpleRules.value.validate().then(success => {
        if (success) {
          emit('handleSubmit')
        }
      })
    }

    const disablesInput = computed(() => itemData.value.id !== undefined && itemData.value.id !== null)

    const onSubmitForm = () => {
      validationForm()
    }

    const statusOptions = [
      { label: 'Ativo', value: 1 },
      { label: 'Inativo', value: 0 },
    ]

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      // eslint-disable-next-line no-param-reassign
      itemData.value.avatar = base64
    })

    return {
      resolveUserRoleVariant,
      avatarText,
      roleOptions,
      statusOptions,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      ufOptions,
      cidadeOptions,
      handleUfsChange,
      handleCidadesChange,
      simpleRules,
      validationForm,
      onSubmitForm,
      disablesInput,
      optionsMask,
      categoriasItems,
      tabelaPrecosOptions,
      itemData,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
